<template>
  <div style="color:white;" >
    <v-container class="my-14">



      <v-card class="pt-5" style="max-width:600px; margin: auto;">
        <v-card-title>
          <h2 class="mtfont">Welcome back!</h2>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              type="email"
              label="email"
              v-model="username"
            />
            <v-text-field
              type="Password"
              label="password"
              v-model="password"
            />
            <small style="cursor: pointer; color: darkred;" v-on:click="requestReset">Reset Password</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="black" class="mtfont" v-on:click="$router.push({name: 'Register'})">Register</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="black"
            style="color: #fecb39;"
            class="mtfont"
            v-on:click="attemptLogin"
          >Login</v-btn>
        </v-card-actions>
      </v-card>



    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: ''
  }),
  methods: {
    attemptLogin(event) {
      this.$store.dispatch('retrieveToken',{
        "username": this.username,
        "password": this.password
      }).then(response => {
        if(response === "SUCCESS") this.$router.push({name: 'Account'});
        else alert('Invalid Username or Password!');
      });
    },
    requestReset(event) {
      if(!this.username || !~this.username.indexOf('@')) return alert('Valid Username Required!');
      alert("Request submitted. Check email for reset url.");
      this.$store.dispatch('submitResetRequest',{ "username": this.username })
          .then(response => {
            if(response.status !== 200) alert('Invalid Username or Password!');
          });
    }
  }
}
</script>

<style scoped>

</style>